import React from 'react';
import { Dialog } from '@mui/material';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ArchiveMorphologyStore } from '../ArchiveMorphologyStore';
import '../../shared/RevealConfirmationDialog/RevealConfirmationDialog.less';

const MobileMorphologyAbout = () => {
  const isOpen = ArchiveMorphologyStore.useState(s => s.toolbar.aboutIsOpen);
  const author = ArchiveMorphologyStore.useState(s => s.author);
  const dateLabel = ArchiveMorphologyStore.useState(s => s.dateLabel);

  const onClose = () => {
    ArchiveMorphologyStore.update(s => {
      s.toolbar.aboutIsOpen = false;
    });
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <div className="revealConfirmationDialogContent">
        <IconButton className="closeButton" onClick={onClose}>
          <CloseIcon/>
        </IconButton>
        <div className="aboutBody">
          {dateLabel}
          <br/>
          <br/>
          Puzzle by {author}.
        </div>
      </div>
    </Dialog>
  );
};

export default MobileMorphologyAbout;